import React from "react";
import {
    CButton,
    CCard,
    CCardBody,
    CCol,
    CContainer,
    CForm,
    CFormInput,
    CRow,
} from "@coreui/react";
import { t } from "../i18n";

export default function LoginPage() {
    const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute("content");

    return (
        <CContainer className="min-vh-100 d-flex align-items-center">
            <CRow className="justify-content-center w-100">
                <CCol md={8} lg={5} xl={4}>
                    <CCard className="shadow">
                        <CCardBody className="p-5">
                            <CForm method="post" action="/users/sign_in">
                                <input type="hidden" name="authenticity_token" value={csrfToken} />

                                <CFormInput
                                    className="mb-3"
                                    type="email"
                                    name="user[email]"
                                    placeholder={t("auth.email")}
                                    autoComplete="email"
                                    required
                                />

                                <CFormInput
                                    className="mb-4"
                                    type="password"
                                    name="user[password]"
                                    placeholder={t("auth.password")}
                                    autoComplete="current-password"
                                    required
                                />

                                <CButton color="primary" type="submit" className="w-100 mb-3">
                                    {t("auth.login")}
                                </CButton>
                            </CForm>

                            <CForm method="post" action="/users/auth/google_oauth2">
                                <input type="hidden" name="authenticity_token" value={csrfToken} />

                                <CButton color="light" type="submit" className="w-100 mb-3">
                                    {t("auth.loginWithGoogle")}
                                </CButton>
                            </CForm>

                            <div className="text-center">
                                <span className="text-body-secondary">{t("auth.noAccount")}</span>
                                <a href="/signup">{t("auth.signupLink")}</a>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CContainer>
    );
}
